import { Column } from '../dataset/column';
import { Metamodel } from '../base/model';
import { Named } from '../base/named';

let mappingId = 0;

@Metamodel.model({})
export class ColumnMappingPair extends Named {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    public __id: number;

    public source: Column;
    public sink: Column;

    constructor(srcName?: string, sinkName?: string) {
        super();
        this.source = new Column(srcName);
        this.sink = new Column(sinkName);
        this.__id = ++mappingId;
    }
}
